"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderId = void 0;
var ProviderId;
(function (ProviderId) {
    ProviderId["Paylama"] = "paylama";
    ProviderId["ContactPay"] = "contact_pay";
})(ProviderId = exports.ProviderId || (exports.ProviderId = {}));
